import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { FleetStat, RiskStats } from '../../types/DeviceTypes'

export interface StatsState {
  dashboardFleetStat?: FleetStat
  dashboardRiskStats?: RiskStats
  dashboardLastUpdated?: string
  tabToShow: string
}

export const initialState: StatsState = {
  dashboardFleetStat: undefined,
  dashboardRiskStats: undefined,
  dashboardLastUpdated: '',
  tabToShow: 'risk',
}

export const statSlice = createSlice({
  name: 'stats',
  initialState,
  reducers: {
    setFleetStat(state, action: PayloadAction<FleetStat | undefined>) {
      state.dashboardFleetStat = action.payload
    },
    setRiskStats(state, action: PayloadAction<RiskStats | undefined>) {
      state.dashboardRiskStats = action.payload
    },
    setTabToShow(state, action: PayloadAction<string>) {
      state.tabToShow = action.payload
    },
    setDashboardLastUpdated(state, action: PayloadAction<string | undefined>) {
      state.dashboardLastUpdated = action.payload
    },
  },
})
export const selectStats = (state: RootState) => state.stats

export const { setFleetStat, setRiskStats, setDashboardLastUpdated, setTabToShow } = statSlice.actions
export default statSlice.reducer
